import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Popper from '@mui/material/Popper'
import { FC, MouseEventHandler, useState } from 'react'

import CategoryChip from './CategoryChip'

export const MoreCategories: FC<{
    items: string[]
}> = ({ items }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [isOpen, setIsOpen] = useState(false)

    const handleHover: MouseEventHandler<HTMLDivElement> = (event) => {
        setAnchorEl(event.currentTarget)
        setIsOpen(true)
    }

    return (
        <Box>
            <Box
                onMouseOver={handleHover}
                onMouseLeave={() => setIsOpen(false)}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    px: '10px',
                    py: 1 / 2,
                    borderRadius: '100px',
                    backgroundColor: `Surface400`,
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    textTransform: 'capitalize',
                    '&:hover': {
                        backgroundColor: `Surface600`,
                    },
                }}
            >
                <Text
                    variant={'body3'}
                    sx={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        color: 'TextSecondary',
                    }}
                >
                    +{items.length}
                </Text>
            </Box>
            <Popper
                id={'categories-menu'}
                anchorEl={anchorEl}
                open={isOpen}
                onMouseOver={() => setIsOpen(true)}
                onMouseLeave={() => setIsOpen(false)}
                keepMounted
                placement={'right'}
                sx={{
                    zIndex: '1000',
                }}
            >
                <Box
                    sx={{
                        ml: 1,
                        borderRadius: `12px`,
                        backgroundColor: `Surface100`,
                        boxShadow: 8,
                        py: 1,
                        px: 1,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {items.map((i) => (
                        <CategoryChip
                            key={i}
                            category={i}
                            sx={{
                                background: 'transparent',
                                pt: 3 / 2,
                                pb: 3 / 2,
                            }}
                        />
                    ))}
                </Box>
            </Popper>
        </Box>
    )
}

export default MoreCategories
